export default __webpack_public_path__ + "static/media/ico-bug-score-elevated.bb9eace3.svg";